<div class="progress-loader">
 
    <mat-progress-spinner [mode]="'indeterminate'">
    </mat-progress-spinner>
 
</div>